import { useShowResponseStatus, useAppSelector, selectCurrencies } from '@/shared';
import { useAddShopCurrencyMutation } from '../store/shops-api';
import { handleShopAddCurrencyError } from '../utils/helpers/shops-errors';

import type { TShopAddCurrencyParams, TShop } from '../store/types';

type Params = {
  shop: TShop;
};

export const useShopBalance = ({ shop }: Params) => {
  const avalableCurrencies = useAppSelector(selectCurrencies);
  const balances = shop.balances;
  const shopCurrencies: string[] = balances.map((item) => item.currency);
  const currenciesToShopAdd: string[] = avalableCurrencies.filter((currency) => !shopCurrencies.includes(currency));

  const [addShopCurrency, { isLoading, isSuccess, error }] = useAddShopCurrencyMutation();
  const addShopCurrencyError = handleShopAddCurrencyError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Валюта успешно добавлена',
    error: addShopCurrencyError,
  });

  const handleAddShopCurrency = async (params: TShopAddCurrencyParams) => {
    await addShopCurrency(params);
  };

  return {
    handleAddShopCurrency,
    addShopCurrency,
    balances,
    isLoading,
    currencies: currenciesToShopAdd,
  };
};
